import React from 'react';
const Benefits = () => {
  return <section className="w-full py-16 px-6 md:px-12 lg:px-24 bg-[#F9F4EE]" data-id="element-14">
      <div className="max-w-4xl mx-auto" data-id="element-15">
        <h2 className="text-3xl font-bold text-center text-[#C17A47] mb-12" data-id="element-16">
          La verdad es que la mayoría de mamás no necesitan aprender recetas
          nuevas complicadas
        </h2>
        <div className="flex flex-col space-y-8" data-id="element-17">
          <div className="flex flex-col md:flex-row items-center gap-6" data-id="element-18">
            <div className="w-full md:w-1/2" data-id="element-19">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/prdwhbcx7PaUHgr8PhEAgB/Generated_Image_September_11%2C_2025_-_3_17PM.png" alt="Mamá cocinando con su hija" className="w-full rounded-lg shadow-lg" data-id="element-20" />
            </div>
            <div className="w-full md:w-1/2 space-y-4" data-id="element-21">
              <h3 className="text-2xl font-semibold text-[#6B5A45]" data-id="element-22">
                Lo que necesitan es un sistema express
              </h3>
              <p className="text-lg text-[#6B5A45]" data-id="element-23">
                Un sistema que se adapte a su ritmo de vida real. Un atajo
                probado. Sin horno. Sin horas en la cocina. Solo platos ricos,
                nutritivos y en la mesa en 15 minutos.
              </p>
            </div>
          </div>
          <div className="flex flex-col md:flex-row-reverse items-center gap-6" data-id="element-24">
            <div className="w-full md:w-1/2" data-id="element-25">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tdGskGWBFxVvNUJNzFGzUa/Generated_Image_September_11%2C_2025_-_3_16PM.png" alt="Mamá cocinando con recetario" className="w-full rounded-lg shadow-lg" data-id="element-26" />
            </div>
            <div className="w-full md:w-1/2 space-y-4" data-id="element-27">
              <h3 className="text-2xl font-semibold text-[#6B5A45]" data-id="element-28">
                No eres desorganizada. No eres floja.
              </h3>
              <p className="text-lg text-[#6B5A45]" data-id="element-29">
                Eres una mamá poderosa que solo necesita herramientas más
                inteligentes. Y hoy las tienes frente a ti.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Benefits;